
import { Component, Vue, Prop } from 'vue-property-decorator';
import throttle from 'lodash.throttle';
import ChangeLanguageIconSp from '@/components/ChangeLanguageIconSp.vue';
import ChangeLanguageIconPc from '@/components/ChangeLanguageIconPc.vue';
import { isIOS12Under } from '@/util/device';

// button height(60px) + bottom margin(20px)
const SHOW_OFFSET = 80;

@Component({
  components: { ChangeLanguageIconSp, ChangeLanguageIconPc }
})
export default class ScrollToBottomButton extends Vue {
  private handleScrollThrottled: (event: Event) => void = (event: Event) => {};
  private previousScrollTop = 0;
  public hideButton = false;

  // スクロール対象がルート要素かどうか
  @Prop({ type: Boolean, required: false, default: false })
  public isRootElement!: boolean;

  @Prop({ type: Element, required: true })
  public scrollTarget!: Element | null;

  @Prop({ type: Element, default: null, required: false })
  public scrollEventTarget!: Element | null;

  private get eventTarget() {
    if (this.scrollEventTarget) return this.scrollEventTarget;

    return this.scrollTarget;
  }

  private handleScroll(event: Event) {
    if (!this.scrollTarget) return;
    const scrollTop = isIOS12Under && this.isRootElement ? window.scrollY : this.scrollTarget.scrollTop;
    // 画面全体のスクロールなこと & アドレスバーの表示非表示に対応するためにwindow.innerHeightを使う
    const clientHeight = window.innerHeight;
    // safariとかで上部で跳ね返った時は意図したスクロールではないのでボタンのshow/hideの評価から外す
    if (scrollTop < 0) return;

    if (scrollTop > this.previousScrollTop) {
      // 下へスクロール
      this.hideButton = true;
    } else {
      // 上へスクロール
      if (this.scrollTarget.scrollHeight - scrollTop - clientHeight >= SHOW_OFFSET) {
        // SHOW_OFFSETの高さよりも上へスクロールした場合
        this.hideButton = false;
      }
    }
    this.previousScrollTop = scrollTop;
  }

  public scrollToBottom() {
    if (!this.scrollTarget) return;
    this.scrollTarget.scrollTo({
      top: this.scrollTarget.scrollHeight,
      behavior: 'smooth'
    });
  }

  mounted() {
    if (!this.eventTarget) return;

    this.handleScrollThrottled = throttle(this.handleScroll, 250);

    // EKYCDEV-4144 iOS、追加書類選択画面で使用すると高さの計算が遅いのでちょっと待ってからボタンの表示判定をする
    setTimeout(() => {
      if (this.scrollTarget) {
        this.hideButton = this.scrollTarget.scrollHeight < this.scrollTarget.clientHeight + SHOW_OFFSET;
      }
    }, 0);
    this.eventTarget.addEventListener('scroll', this.handleScrollThrottled);
  }

  unmounted() {
    if (!this.eventTarget) return;

    if (this.handleScrollThrottled) {
      this.eventTarget.removeEventListener('scroll', this.handleScrollThrottled);
    }
  }
}
